<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2><span>Brand Safety Risk</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon" data-placement="top" data-toggle="tooltip" enTooltip
          title="Risk factors to advertiser Brand Safety broken down by both in-app content such as images, and descriptive text about the app">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-brandsafety-risk [os]='os' [data]="data" [isFreemium]="isFreemium" (anchorClick)="anchorClick.emit($event)">
      </app-brandsafety-risk>
    </div>
  </div>
</div>
